import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=deb87978&scoped=true&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"
import style0 from "@/styles/VerticalSwiper.sass?vue&type=style&index=0&id=deb87978&lang=sass&scoped=true&"
import style1 from "./Transfers.vue?vue&type=style&index=1&id=deb87978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb87978",
  null
  
)

export default component.exports